/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_By_Time_HelpInputs */

const en_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Event Groups are created based on the media duration divided by the number of segments. Events are then placed into each new Event Group based on their start and end times.`)
};

const fr_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De nouveaux groupes d'evenements sont crees en fonction de la duree du media divisee par le nombre de segments. Les evenements sont ensuite places dans chaque nouveau groupe d'evenements en fonction de leurs heures de debut et de fin.`)
};

const de_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ereignisgruppen werden auf Basis der Mediendauer geteilt durch die Anzahl der Segmente erstellt. Anschließend werden Ereignisse anhand ihrer Start- und Endzeit den jeweiligen Ereignisgruppen zugeordnet.`)
};

const it_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I nuovi gruppi di eventi vengono creati in base alla durata del contenuto multimediale divisa per il numero di segmenti. Gli eventi vengono quindi inseriti in ciascun nuovo gruppo in base all'orario di inizio e di fine.`)
};

const ru_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые группы событий создаются на основе длительности медиаконтента, деленной на количество сегментов. Затем события помещаются в каждую новую группу событий в соответствии с временем их начала и окончания.`)
};

const es_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los nuevos grupos de eventos se crean según la duración del contenido multimedia dividida por el número de segmentos. Los eventos se asignan a cada nuevo grupo según su hora de inicio y de fin.`)
};

const zh_cn2_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统会根据媒体时长除以片段数量来创建新的事件组。然后，事件会根据其开始和结束时间被分配到各个新的事件组中。`)
};

const ja_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントグループは、メディアの長さをセグメント数で割った値に基づいて作成されます。イベントは、開始時間と終了時間に基づいて各新しいイベントグループに配置されます。`)
};

const hi_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया की अवधि को सेगमेंट की संख्या से विभाजित करके नए इवेंट ग्रुप बनाए जाते हैं। फिर इवेंट्स को उनके प्रारंभ और समाप्ति समय के आधार पर प्रत्येक नए इवेंट ग्रुप में रखा जाता है।`)
};

const pt_pt2_segment_event_group_by_time_help = /** @type {(inputs: Segment_Event_Group_By_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos Grupos de Eventos são criados com base na duração da mídia dividida pelo número de segmentos. Os eventos são então alocados em cada novo Grupo de Eventos de acordo com seus horários de início e término.`)
};

/**
* | output |
* | --- |
* | "New Event Groups are created based on the media duration divided by the number of segments. Events are then placed into each new Event Group based on their s..." |
*
* @param {Segment_Event_Group_By_Time_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_by_time_help = /** @type {((inputs?: Segment_Event_Group_By_Time_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_By_Time_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_by_time_help(inputs)
	if (locale === "de") return de_segment_event_group_by_time_help(inputs)
	if (locale === "it") return it_segment_event_group_by_time_help(inputs)
	if (locale === "ru") return ru_segment_event_group_by_time_help(inputs)
	if (locale === "es") return es_segment_event_group_by_time_help(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_by_time_help(inputs)
	if (locale === "ja") return ja_segment_event_group_by_time_help(inputs)
	if (locale === "hi") return hi_segment_event_group_by_time_help(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_by_time_help(inputs)
	return en_segment_event_group_by_time_help(inputs)
});